<template>
  <b-row
    class="px-2 py-3"
    :class="$style.wrapper"
  >
    <b-col
      :cols="2"
      :md="2"
      :lg="1"
      class="d-flex align-items-center justify-content-center pl-0 pr-1"
      :class="$style.leagueLogoWrapper"
    >
      <b-link
        :to="{ name: 'round-detail', params: { roundId: round.id } }"
        class="w-100 text-center"
      >
        <b-img
          :src="round.season.league.image_url"
          fluid
          class="p-0 p-sm-2"
          :class="$style.image"
        />
      </b-link>
    </b-col>
    <b-col class="pr-0">
      <b-row>
        <b-col
          :class="$style.dateWrapper"
          class="d-flex align-items-center"
        >
          <b-link
            :to="{ name: 'round-detail', params: { roundId: round.id } }"
            :class="$style.cursorPointer"
            router-tag="span"
          >
            {{ round.startDateTimeFormatted }}
          </b-link>
        </b-col>
        <b-col
          :cols="5"
          :md="4"
          :lg="3"
        >
          <b-link
            :to="{ name: 'round-detail', params: { roundId: round.id } }"
            :class="$style.cursorPointer"
            router-tag="span"
          >
            <BaseBadge :variant="roundBadgeVariant">
              {{ $t(`round.status.${round.status}`) }}
            </BaseBadge>
          </b-link>
        </b-col>

        <b-col :cols="12">
          <b-link
            :to="{ name: 'round-detail', params: { roundId: round.id } }"
            :class="$style.cursorPointer"
            router-tag="span"
          >
            <BaseTextH2>{{ round.name[$i18n.locale] }}</BaseTextH2>
          </b-link>
        </b-col>

        <b-col
          :cols="12"
          class="d-flex justify-content-start flex-column"
        >
          <b-row>
            <b-col
              v-if="round.season.league.type === 1"
              :cols="12"
            >
              <b-row v-if="round.prizes.first">
                <b-col
                  cols="auto"
                  class="pr-1 d-flex align-items-center"
                >
                  <b-link
                    :to="{ name: 'round-detail', params: { roundId: round.id } }"
                    :class="$style.cursorPointer"
                    router-tag="span"
                  >
                    <font-awesome-icon :icon="['far', 'gem']" />
                  </b-link>
                </b-col>
                <b-col class="pl-1">
                  <b-link
                    :to="{ name: 'round-detail', params: { roundId: round.id } }"
                    :class="$style.cursorPointer"
                    router-tag="span"
                  >
                    {{ $t('jackpot') }}:
                    <span :class="$style.jackpotValue">
                      {{ round.prizes.first.prize }}{{ currency }}
                    </span>
                  </b-link>
                  <font-awesome-icon
                    :class="$style.jackpotInfoIcon"
                    icon="info-circle"
                    size="lg"
                    @click="() => openRoundJackpotOverviewModal({
                      roundId: round.id,
                      prizes: round.prizes,
                      leagueType: round.season.league.type,
                    })"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col
              v-else-if="round.jackpot"
              :cols="12"
            >
              <b-row>
                <b-col
                  cols="auto"
                  class="pr-1 d-flex align-items-center"
                >
                  <b-link
                    :to="{ name: 'round-detail', params: { roundId: round.id } }"
                    :class="$style.cursorPointer"
                    router-tag="span"
                  >
                    <font-awesome-icon :icon="['far', 'gem']" />
                  </b-link>
                </b-col>
                <b-col class="pl-1">
                  <b-link
                    :to="{ name: 'round-detail', params: { roundId: round.id } }"
                    :class="$style.cursorPointer"
                    router-tag="span"
                  >
                    {{ $t('live-jackpot') }}:
                    <span :class="$style.jackpotValue">{{ round.jackpot }}{{ currency }} </span>
                  </b-link>
                  <font-awesome-icon
                    :class="$style.jackpotInfoIcon"
                    icon="info-circle"
                    size="lg"
                    @click="() => openRoundJackpotOverviewModal({
                      roundId: round.id,
                      jackpot: round.jackpot,
                      leagueType: round.season.league.type,
                    })"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col
              v-else-if="round.season.league.minimum_jackpot && !isRoundClosed"
              :cols="12"
            >
              <b-row>
                <b-col
                  cols="auto"
                  class="pr-1 d-flex align-items-center"
                >
                  <font-awesome-icon :icon="['far', 'gem']" />
                </b-col>
                <b-col class="pl-1">
                  <b-link
                    :to="{ name: 'round-detail', params: { roundId: round.id } }"
                    :class="$style.cursorPointer"
                    router-tag="span"
                  >
                    {{ $t('guaranteed-jackpot') }}:
                  </b-link>
                  <span :class="$style.jackpotValue">{{ round.season.league.minimum_jackpot }}{{ currency }} </span>
                  <font-awesome-icon
                    :class="$style.jackpotInfoIcon"
                    icon="info-circle"
                    size="lg"
                    @click="() => openRoundJackpotOverviewModal({
                      roundId: round.id,
                      guaranteedJackpot: round.season.league.minimum_jackpot,
                      leagueType: round.season.league.type,
                    })"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col
              v-if="!isRoundClosed"
              :cols="12"
            >
              <b-link
                :to="{ name: 'round-detail', params: { roundId: round.id } }"
                :class="$style.cursorPointer"
                router-tag="span"
              >
                <b-row>
                  <b-col
                    cols="auto"
                    class="pr-1 d-flex align-items-center"
                  >
                    <font-awesome-icon icon="users" />
                  </b-col>
                  <b-col class="pl-1">
                    <template v-if="round.season.league.type !== 1">
                      {{ $t('lineup-status') }}:
                    </template>
                    <template v-else>
                      {{ $t('prediction-status') }}:
                    </template>
                    <span :class="$style[lineupStatusClass]">{{ lineupStatusText }}</span>
                  </b-col>
                </b-row>
              </b-link>
            </b-col>
            <b-col
              v-else
              :cols="12"
            >
              <b-link
                :to="{ name: 'round-detail', params: { roundId: round.id } }"
                :class="$style.cursorPointer"
                router-tag="span"
              >
                <b-row>
                  <b-col
                    cols="auto"
                    class="pr-1 d-flex align-items-center"
                  >
                    <font-awesome-icon icon="star" />
                  </b-col>
                  <b-col class="pl-1">
                    {{ $t('score') }}:
                    <strong>
                      {{ round.score }}
                      /
                      <template v-if="round.season.league.type === 1">1</template>
                      <template v-else>8</template>
                    </strong>
                  </b-col>
                </b-row>
              </b-link>
            </b-col>
          </b-row>
        </b-col>

        <b-col class="d-flex pt-3">
          <router-link :to="{ name: 'round-detail', params: { roundId: round.id } }">
            <BaseButton
              is-rounded
              size="sm"
              :variant="buttonVariant"
            >
              <span class="px-4">{{ buttonText }}</span>
            </BaseButton>
          </router-link>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from 'vuex'
import BaseBadge from '@/components/Atoms/BaseBadge'
import BaseTextH2 from '@/components/Atoms/Typography/BaseTextH2'
import BaseButton from '@/components/Atoms/BaseButton'
import { ROUND_STATUSES } from '@/store/modules/rounds'

export default {
  name: 'TheRoundLobbyRow',
  components: {
    BaseButton,
    BaseBadge,
    BaseTextH2,
  },
  props: {
    round: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    currency() {
      return process.env.VUE_APP_CURRENCY_SYMBOL
    },
    roundBadgeVariant() {
      switch (this.round.status) {
      case ROUND_STATUSES.live: return 'green-outline'
      case ROUND_STATUSES.upcoming: return 'orange-outline'
      default: return 'black-outline'
      }
    },
    isRoundClosed() {
      return this.round.status === ROUND_STATUSES.closed
    },
    buttonVariant() {
      switch (this.round.status) {
      case ROUND_STATUSES.live: return 'green'
      case ROUND_STATUSES.upcoming: return 'orange'
      default: return 'blue'
      }
    },
    buttonText() {
      switch (this.round.status) {
      case ROUND_STATUSES.live: return this.$t('round-detail')
      case ROUND_STATUSES.upcoming:
        switch (this.round.lineup_status) {
        case 2: return this.$t('finish-lineup')
        case 3: return this.round.season.league.type !== 1
          ? this.$t('see-my-players')
          : this.$t('see-my-picks')
        default: return this.$t('pick-my-players')
        }
      default: return this.$t('see-results')
      }
    },
    lineupStatusText() {
      switch (this.round.lineup_status) {
      case 2: return this.$t('incomplete')
      case 3: return this.$t('ready')
      default:
        switch (this.round.status) {
        case ROUND_STATUSES.live: return this.$t('incomplete')
        default: return this.$t('pending')
        }
      }
    },
    lineupStatusClass() {
      switch (this.round.lineup_status) {
      case 2: return 'lineStatusIncomplete'
      case 3: return 'lineStatusCompleted'
      default:
        switch (this.round.status) {
        case ROUND_STATUSES.live: return 'lineStatusIncomplete'
        default: return 'lineStatusPending'
        }
      }
    },
  },
  methods: {
    ...mapActions({
      openRoundJackpotOverviewModal: 'rounds/roundJackpotOverview/openRoundJackpotOverviewModal',
    }),
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .wrapper {
    background-color: $color-white;
  }
  .leagueLogoWrapper {
    border-right: 1px solid rgba(0,0,0, .15);
  }
  .dateWrapper {
    font-size: $font-size-small;
  }
  .jackpotInfoIcon {
    cursor: pointer;
  }
  .jackpotValue {
    color: $color-tomato;
    font-weight: 600;
  }

  .lineStatusIncomplete {
    color: $color-tomato;
    font-weight: 600;
  }
  .lineStatusCompleted {
    color: $color-bubble-bobble-green;
    font-weight: 600;
  }
  .lineStatusPending {
    color: $color-bleu-de-france;
    font-weight: 600;
  }
  .cursorPointer {
    cursor: pointer;
  }
</style>
